<template>
    <div class="m-pop">
        <div class="pop-mask"></div>
        <div class="pop-con">
            <div class="title">
                <h3>系统提示</h3>
                <div class="close" @click="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="info-box">
                <div class="info">
                    <h3>{{ systemInfo || '系统维护中，请稍后再试' }}</h3>
                </div>
            </div>
            <div class="bot-btn">
                <el-button type="primary" @click="close">知道了</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        systemInfo: {
            type: String,
            default: '系统维护中，请稍后再试'
        }
    },
    data() {
        return {}
    },
    methods: {
        close: function () {
            this.$emit('close')
        }
    }
}
</script>
